import PressRoomSocialNetworks, {
  BlockStyle,
  PressroomBlockStyle,
} from './PressRoomSocialNetworks';
import PressRoomSocialNetworksWithoutContext from './PressRoomSocialNetworksWithoutContext';

export type { BlockStyle, PressroomBlockStyle };

export { PressRoomSocialNetworks, PressRoomSocialNetworksWithoutContext };
